module.exports = __webpack_public_path__ + "static/media/parkMobile@2x.cad559e1.png";